import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { TTP_PORTAL_URL } from "Config";
import { setCurrentOrganization } from "thunks";
import Community from "./Community";
import _ from "i18n";

export class SelectCommunity extends PureComponent {
  static defaultProps = {
    userOrganizations: []
  };

  static propTypes = {
    userOrganizations: PropTypes.array,
    setCurrentOrganization: PropTypes.func
  };

  handleSelectOrganization = organization => {
    this.props.setCurrentOrganization(organization);
  };

  renderOrganizations() {
    const { user } = this.props.auth;
    const { userOrganizations, selectedOrganization } = user;
    let communities = [...userOrganizations];

    if (!user) {
      return null;
    }
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      !userOrganizations.find(client => client.id === selectedOrganization.id)
    ) {
      communities.unshift({ ...selectedOrganization, disabled: true });
    }

    return communities.map(client => (
      <Community
        key={client.id}
        community={client}
        onClick={() => this.handleSelectOrganization(client)}
      />
    ));
  }

  render() {
    return (
      <div id="select-community">
        <div className="medium-11">
          <button
            onClick={() => (window.location.href = `${TTP_PORTAL_URL}`)}
            className="sc__back-button medium-3"
          >
            <img
              src="img/icons/portal.svg"
              className="sc__back-button_img"
              alt="back home"
            />
            {_("back")}
          </button>
          <div className="sc__container medium-12">
            <div className="sc__header">
              <div>
                <h3>{_("selectCommunity")}</h3>
                <span>{_("listCommunity")}</span>
              </div>
            </div>
            <div className="sc__header_logo" />
            <div className="sc__communities grid-x grid-margin-x">
              {this.renderOrganizations()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  setCurrentOrganization: organization =>
    dispatch(setCurrentOrganization(organization))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCommunity);



// WEBPACK FOOTER //
// ./src/components/SelectCommunity/SelectCommunity.js